module.exports = "/_next/static/images/SanofiImage-5e5bb3cfc9317fad93b6c17e8c3a0fd3.jpg";